import moment from 'moment-timezone'

export default {
  namespaced: true,
  state () {
    return {
      info: {
        id: null,
        num: null,
        supplier: null,
        title: null,
        fy: null, // Default = this year
        arrival_date: null,
        arrival_time: null,
        port: null,
        pic: null,
        needreport: false,
        needrepack: false,
        awb: null,
        flight: null,
        etd: null,
        auction_date: null,
        auctionf_date: null,
        options_bp: null,
        note: null,
        scrap: null,
        journal_date_auto: true,
        journal_date: null,
        supseq: null,
        docsok: 0,
        acc_confirmed_by: null,
        acc_confirmed_at: null,
        sales_confirmed_by: null,
        sales_confirmed_at: null,
        salesreport_final_by: null,
        salesreport_final_at: null,
        version: 1,
        confirm_no_claim: null,
        import_from: null,
        is_pte_member: null
      },
      logi: {
        id: null,
        shipment: null,
        bundles: null,
        boxes: null,
        stems: null,
        naccs_no: null,
        day_kensa: 0,
        day_fumi: 0,
        day_shukka: 0,
        options_pq: null,
        fumigation_type: null,
        mailbody: null,
        mailed: false,
        uwaya: null,
        hanshutsu_at: null,
        warehouse: null,
        logi_center: null,
        deban_date: null,
        deban_time: null,
        deban_feet: null,
        hyoshi: false
      },
      shipment_temperatures: [],
      shipment_bug: [],
      cost: {
        id: null,
        shipment: null,
        rate: null,
        custom_rate: null,
        invoice_no1: '',
        invoice_date1: null,
        invoice_foreign1: null,
        invoice1: null,
        invoice_payee1: null,
        invoice_payment_date1: null,
        invoice_no2: '',
        invoice_date2: null,
        invoice_foreign2: null,
        invoice2: null,
        invoice_payee2: null,
        invoice_payment_date2: null,
        invoice_no3: '',
        invoice_date3: null,
        invoice_foreign3: null,
        invoice3: null,
        invoice_payee3: null,
        invoice_payment_date3: null,
        invoice_no4: '',
        invoice_date4: null,
        invoice_foreign4: null,
        invoice4: null,
        invoice_payee4: null,
        invoice_payment_date4: null,
        invoice_no5: '',
        invoice_date5: null,
        invoice_foreign5: null,
        invoice5: null,
        invoice_payee5: null,
        invoice_payment_date5: null,
        credit_coming: false,
        credit_no: null,
        credit_date: null,
        credit_foreign: null,
        credit: null,
        credit_payee: null,
        credit_payment_date: null,
        credit_statement: false,
        adjustment_foreign: null,
        adjustment: null,
        adjustment_payee: null,
        adjustment_payment_date: null,
        airfreight_no1: '',
        airfreight_foreign1: null,
        airfreight1: null,
        airfreight_divide1: null,
        airfreight_payee1: null,
        airfreight_payment_date1: null,
        airfreight_date1: null,
        airfreight_no2: '',
        airfreight_foreign2: null,
        airfreight2: '',
        airfreight_divide2: null,
        airfreight_payee2: null,
        airfreight_payment_date2: null,
        airfreight_date2: null,
        airfreight_no3: '',
        airfreight_foreign3: null,
        airfreight3: '',
        airfreight_divide3: null,
        airfreight_payee3: null,
        airfreight_payment_date3: null,
        airfreight_date3: null,
        clearing_date: null,
        clearing: null,
        clearing_divide: null,
        weight: null,
        fumigation_handling: null,
        fumigation_handling_divide: null,
        fumigation_date: null,
        fumigation: null,
        fumigation_company: null,
        fumigation_requested_date: null,
        disposeall: false,
        dispose: null,
        supplier_fumigation_mail_sent: false,
        supplier_fumigation_method: false,
        supplier_fumigation_credit_no: null,
        supplier_fumigation_credit_date: null,
        supplier_fumigation_foreign: null,
        supplier_fumigation: null,
        supplier_fumigation_divide: null,
        supplier_fumigation_payee: null,
        supplier_fumigation_payment_date: null,
        deban: null,
        shifting: null,
        airpacking: null,
        trans_dom: null,
        trans_dom_note: '',
        purchase_adjustment: null,
        custom: null,
        rinji_kaicho: null,
        repack: null,
        claim: null,
        loyality: null,
        doc_sent_at: null,
        candf: null,
        siire: null,
        accnote: '',
        invoice_statement: false,
        customer_claim: null
      },
      summary: {
        shipment: null,
        arrivals: null, // sum
        rate: null,
        custom_rate: null,
        invoice_no1: '',
        invoice_date1: null,
        invoice_foreign1: null,
        invoice1: null,
        invoice_payee1: null,
        invoice_payment_date1: null,
        invoice_no2: '',
        invoice_date2: null,
        invoice_foreign2: null,
        invoice2: null,
        invoice_payee2: null,
        invoice_payment_date2: null,
        invoice_no3: '',
        invoice_date3: null,
        invoice_foreign3: null,
        invoice3: null,
        invoice_payee3: null,
        invoice_payment_date3: null,
        invoice_no4: '',
        invoice_date4: null,
        invoice_foreign4: null,
        invoice4: null,
        invoice_payee4: null,
        invoice_payment_date4: null,
        invoice_no5: '',
        invoice_date5: null,
        invoice_foreign5: null,
        invoice5: null,
        invoice_payee5: null,
        invoice_payment_date5: null,
        airfreight_no1: '',
        airfreight_foreign1: null,
        airfreight1: null,
        airfreight_divide1: null,
        airfreight_payee1: null,
        airfreight_payment_date1: null,
        airfreight_date1: null,
        airfreight_no2: '',
        airfreight_foreign2: null,
        airfreight2: '',
        airfreight_divide2: null,
        airfreight_payee2: null,
        airfreight_payment_date2: null,
        airfreight_date2: null,
        airfreight_no3: '',
        airfreight_foreign3: null,
        airfreight3: '',
        airfreight_divide3: null,
        airfreight_payee3: null,
        airfreight_payment_date3: null,
        airfreight_date3: null,
        supplier_fumigation: null,
        supplier_fumigation_foreign: null,
        supplier_fumigation_divide: null,
        supplier_fumigation_payee: null,
        supplier_fumigation_payment_date: null,
        credit: null,
        credit_foreign: null,
        credit_payee: null,
        credit_payment_date: null,
        credit_statement: null,
        adjustment: null,
        adjustment_foreign: null,
        adjustment_payee: null,
        adjustment_payment_date: null,
        candf: null, // sum
        invoice_statement: null,
        trans_dom: null,
        deban: null,
        shifting: null,
        airpacking: null,
        uwaya: null, // logi
        clearing_date: null,
        clearing: null, // sum
        clearing_divide: null,
        fumigation_handling: null,
        fumigation_company: null, // logi
        fumigation_date: null,
        fumigation: null, // sum
        dispose: null, // sum
        purchase_adjustment: null,
        custom: null,
        rinji_kaicho: null,
        claim: null,
        siire: null, // sum
        sales: null,
        profit: null,
        acc_confirmed_by: null,
        acc_confirmed_at: null,
        sales_confirmed_by: null,
        sales_confirmed_at: null,
        salesreport_final_by: null,
        salesreport_final_at: null,
        customer_claim: null
      },
      shipment_sales_info: [],
      filetypes: [],
      repack: [],
      ports: [],
      suppliers: [],
      members: [],
      shipments: [],
      options_bps: [],
      options_pqs: [],
      fumigation_types: [],
      fumigation_companies: [],
      uwayas: [],
      items: [],
      worms: [],
      hanshutsu_statuses: [],
      awb_to_uwayas: [],
      warehouses: [],
      logi_centers: [],
      logi_center_mappings: [],
      temperatures: [],
      temperature_states: [],
      shipment_file_needs: [],
      shipment_files: [],
      shipment_formulas: [],
      selected_ids: [],
      selected_chart_ids: [],
      selected_all_dates: [],
      temperature_presets: [],
      preset_default: null,
      repack_places: [],
      payees: [],
      claim: []
    }
  },
  getters: {
    info (state) {
      return state.info
    },
    logi (state) {
      return state.logi
    },
    cost (state) {
      return state.cost
    },
    shipment_bug (state) {
      return state.shipment_bug
    },
    repack (state) {
      return state.repack
    },
    summary (state) {
      return state.summary
    },
    filetypes (state) {
      return state.filetypes
    },
    ports (state) {
      return state.ports
    },
    suppliers (state) {
      return state.suppliers
    },
    members (state) {
      return state.members
    },
    shipments (state) {
      return state.shipments
    },
    options_bps (state) {
      return state.options_bps
    },
    options_pqs (state) {
      return state.options_pqs
    },
    fumigation_types (state) {
      return state.fumigation_types
    },
    fumigation_companies (state) {
      return state.fumigation_companies
    },
    uwayas (state) {
      return state.uwayas
    },
    items (state) {
      return state.items
    },
    worms (state) {
      return state.worms
    },
    hanshutsu_statuses (state) {
      return state.hanshutsu_statuses
    },
    awb_to_uwayas (state) {
      return state.awb_to_uwayas
    },
    warehouses (state) {
      return state.warehouses
    },
    logi_centers (state) {
      return state.logi_centers
    },
    logi_center_mappings (state) {
      return state.logi_center_mappings
    },
    temperatures (state) {
      return state.temperatures
    },
    temperature_states (state) {
      return state.temperature_states
    },
    temperature_presets (state) {
      return state.temperature_presets
    },
    shipment_temperatures (state) {
      return state.shipment_temperatures
    },
    shipment_file_needs (state) {
      return state.shipment_file_needs
    },
    shipment_files (state) {
      return state.shipment_files
    },
    shipment_formulas (state) {
      return state.shipment_formulas
    },
    shipment_formula (state, prop) {
      let index = state.shipment_formulas.findIndex((row) => {
        return row.property === prop
      })
      return index > -1 ? state.shipment_formulas['index'] : null
    },
    selected_ids (state) {
      return state.selected_ids
    },
    selected_chart_ids (state) {
      return state.selected_chart_ids
    },
    selected_all_dates (state) {
      return state.selected_all_dates
    },
    preset_default (state) {
      return state.preset_default
    },
    repack_places (state) {
      return state.repack_places
    },
    payees (state) {
      return state.payees
    },
    claim (state) {
      return state.claim
    },
    shipment_sales_info (state) {
      return state.shipment_sales_info
    }
  },
  mutations: {
    updateInfo (state, info) {
      Object.assign(state.info, info)
      const conditions = [false, false, false]
      conditions[0] = !!state.info.supplier
      conditions[1] = !!state.info.port
      conditions[2] = !state.logi.logi_center || !!state.logi.logi_center.is_default
      if (conditions.every(v => v)) {
        const logiCenter = state.logi_center_mappings.find(mapping => {
          return mapping.supplier.id === state.info.supplier.id && mapping.port.id === state.info.port.id
        })

        if (logiCenter && state.logi_centers.length > 0) {
          let logiCenterMapping = state.logi_centers.find(logiCenterBiz => {
            return logiCenterBiz.id === logiCenter.logi_center.id
          })

          if (logiCenterMapping) {
            state.logi.logi_center = Object.assign({}, logiCenterMapping)
          }
        }
      }
    },
    updateLogi (state, logi) {
      Object.assign(state.logi, logi)
      if (!state.logi.logi_center && state.logi_centers.length > 0) {
        const defaultLogiCenter = state.logi_centers.find(logiCenter => {
          return logiCenter.is_default
        })
        if (defaultLogiCenter) {
          state.logi.logi_center = Object.assign({}, defaultLogiCenter)
        }
      }
    },
    updateCost (state, cost) {
      Object.assign(state.cost, cost)
    },
    updateRepack (state, repack) {
      state.repack = repack
    },
    updateSummary (state, summary) {
      Object.assign(state.summary, summary)
    },
    updateFiletypes (state, filetypes) {
      state.filetypes = filetypes
    },
    updateShipmentTemperatures (state, shipmentTemperatures) {
      state.shipment_temperatures = shipmentTemperatures
    },
    selectShipmentTemperature (state, [index, prop]) {
      Object.assign(state.shipment_temperatures[index], prop)
    },
    updateShipmentBug (state, bug) {
      state.shipment_bug = bug
    },
    setArrivalDate (state, arrivalDate) {
      state.info.arrival_date = arrivalDate
    },
    setPorts (state, ports) {
      state.ports = ports
    },
    setSuppliers (state, suppliers) {
      state.suppliers = suppliers
    },
    addItemToArrayState (state, payload) {
      state[payload.key] = [...state[payload.key], payload.value]
    },
    setMembers (state, members) {
      state.members = members
    },
    setShipments (state, shipments) {
      state.shipments = shipments
    },
    setOptionsBps (state, optionsBps) {
      state.options_bps = optionsBps
    },
    setOptionsPqs (state, optionsPqs) {
      state.options_pqs = optionsPqs
    },
    setFumigationTypes (state, fumigationTypes) {
      state.fumigation_types = fumigationTypes
    },
    setFumigationCompanies (state, fumigationCompanies) {
      state.fumigation_companies = fumigationCompanies
    },
    setUwayas (state, uwayas) {
      state.uwayas = uwayas
    },
    setItems (state, items) {
      state.items = items
    },
    setWorms (state, worms) {
      state.worms = worms
    },
    setHanshutsuStatuses (state, hanshutsuStatuses) {
      state.hanshutsu_statuses = hanshutsuStatuses
    },
    setAwbToUwayas (state, uwayas) {
      state.awb_to_uwayas = uwayas
    },
    setWarehouses (state, warehouses) {
      state.warehouses = warehouses
    },
    setLogiCenters (state, logiCenters) {
      state.logi_centers = logiCenters
    },
    setLogiCenterMappings (state, logiCenterMappings) {
      state.logi_center_mappings = logiCenterMappings
    },
    setTemperatures (state, temperatures) {
      state.temperatures = temperatures
    },
    setTemperatureStates (state, temperatureStates) {
      state.temperature_states = temperatureStates
    },
    setTemperaturePresets (state, temperaturePresets) {
      state.temperature_presets = temperaturePresets
    },
    setRepackPlaces (state, repackPlaces) {
      state.repack_places = repackPlaces
    },
    setPayees (state, payees) {
      state.payees = payees
    },
    setPresetDefault (state, presetDefault) {
      state.preset_default = presetDefault
    },
    updateShipmentFileNeeds (state, shipmentFileNeeds) {
      state.shipment_file_needs = shipmentFileNeeds
    },
    setShipmentFiles (state, shipmentFiles) {
      state.shipment_files = shipmentFiles
    },
    setShipmentSalesInfo (state, shipmentSalesInfo) {
      state.shipment_sales_info = shipmentSalesInfo
    },
    selectShipmentSalesInfo (state, [index, prop]) {
      Object.assign(state.shipment_sales_info[index], prop)
    },
    setClaimInfo (state, claimsInfo) {
      state.claim = claimsInfo
    },
    selectClaimInfo (state, [index, prop]) {
      Object.assign(state.claim[index], prop)
    },
    resetInfo (state) {
      state.info = {
        id: null,
        num: '',
        supplier: null,
        title: '',
        fy: parseInt(moment().format('YYYY')), // Default = this year
        arrival_date: null,
        arrival_time: null,
        port: null,
        pic: null,
        needreport: false,
        needrepack: false,
        awb: '',
        flight: '',
        etd: null,
        auction_date: null,
        auctionf_date: null,
        options_bp: null,
        note: '',
        scrap: '',
        journal_date_auto: true,
        journal_date: null,
        supseq: null,
        docsok: 0,
        acc_confirmed_by: null,
        acc_confirmed_at: null,
        sales_confirmed_by: null,
        sales_confirmed_at: null,
        salesreport_final_by: null,
        salesreport_final_at: null,
        version: 1,
        confirm_no_claim: null,
        import_from: null,
        is_pte_member: null
      }
    },
    resetLogi (state) {
      state.logi = {
        id: null,
        shipment: null,
        bundles: null,
        boxes: null,
        stems: null,
        naccs_no: null,
        day_kensa: 0,
        day_fumi: 0,
        day_shukka: 0,
        options_pq: null,
        fumigation_type: null,
        mailbody: null,
        mailed: false,
        uwaya: null,
        hanshutsu_at: null,
        warehouse: null,
        logi_center: null,
        deban_date: null,
        deban_time: null,
        deban_feet: null,
        hyoshi: false
      }
      if (!state.logi.logi_center && state.logi_centers.length > 0) {
        const defaultLogiCenter = state.logi_centers.find(logiCenter => {
          return logiCenter.is_default
        })
        if (defaultLogiCenter) {
          state.logi.logi_center = Object.assign({}, defaultLogiCenter)
        }
      }
    },
    resetCost (state) {
      state.cost = {
        id: null,
        shipment: null,
        rate: null,
        custom_rate: null,
        invoice_no1: '',
        invoice_date1: null,
        invoice_foreign1: null,
        invoice1: null,
        invoice_payee1: null,
        invoice_payment_date1: null,
        invoice_no2: '',
        invoice_date2: null,
        invoice_foreign2: null,
        invoice2: null,
        invoice_payee2: null,
        invoice_payment_date2: null,
        invoice_no3: '',
        invoice_date3: null,
        invoice_foreign3: null,
        invoice3: null,
        invoice_payee3: null,
        invoice_payment_date3: null,
        invoice_no4: '',
        invoice_date4: null,
        invoice_foreign4: null,
        invoice4: null,
        invoice_payee4: null,
        invoice_payment_date4: null,
        invoice_no5: '',
        invoice_date5: null,
        invoice_foreign5: null,
        invoice5: null,
        invoice_payee5: null,
        invoice_payment_date5: null,
        credit_coming: false,
        credit_foreign: null,
        credit_no: null,
        credit_date: null,
        credit: null,
        credit_payee: null,
        credit_payment_date: null,
        credit_statement: false,
        adjustment_foreign: null,
        adjustment: null,
        adjustment_payee: null,
        adjustment_payment_date: null,
        airfreight_no1: '',
        airfreight_foreign1: null,
        airfreight1: null,
        airfreight_divide1: null,
        airfreight_payee1: null,
        airfreight_payment_date1: null,
        airfreight_date1: null,
        airfreight_no2: '',
        airfreight_foreign2: null,
        airfreight2: '',
        airfreight_divide2: null,
        airfreight_payee2: null,
        airfreight_payment_date2: null,
        airfreight_date2: null,
        airfreight_no3: '',
        airfreight_foreign3: null,
        airfreight3: '',
        airfreight_divide3: null,
        airfreight_payee3: null,
        airfreight_payment_date3: null,
        airfreight_date3: null,
        clearing_date: null,
        clearing: null,
        clearing_divide: null,
        weight: null,
        fumigation_handling: null,
        fumigation_handling_divide: null,
        fumigation_date: null,
        fumigation: null,
        fumigation_company: null,
        fumigation_requested_date: null,
        disposeall: false,
        dispose: null,
        supplier_fumigation_mail_sent: false,
        supplier_fumigation_method: false,
        supplier_fumigation_credit_no: null,
        supplier_fumigation_credit_date: null,
        supplier_fumigation_foreign: null,
        supplier_fumigation: null,
        supplier_fumigation_divide: null,
        supplier_fumigation_payee: null,
        supplier_fumigation_payment_date: null,
        deban: null,
        shifting: null,
        airpacking: null,
        trans_dom: null,
        trans_dom_note: '',
        purchase_adjustment: null,
        custom: null,
        rinji_kaicho: null,
        repack: null,
        claim: null,
        loyality: null,
        doc_sent_at: null,
        candf: null,
        siire: null,
        accnote: '',
        invoice_statement: false,
        customer_claim: null
      }
    },
    resetSummary (state) {
      state.summary = {
        shipment: null,
        arrivals: null,
        rate: null,
        custom_rate: null,
        invoice_no1: '',
        invoice_date1: null,
        invoice_foreign1: null,
        invoice1: null,
        invoice_payee1: null,
        invoice_payment_date1: null,
        invoice_no2: '',
        invoice_date2: null,
        invoice_foreign2: null,
        invoice2: null,
        invoice_payee2: null,
        invoice_payment_date2: null,
        invoice_no3: '',
        invoice_date3: null,
        invoice_foreign3: null,
        invoice3: null,
        invoice_payee3: null,
        invoice_payment_date3: null,
        invoice_no4: '',
        invoice_date4: null,
        invoice_foreign4: null,
        invoice4: null,
        invoice_payee4: null,
        invoice_payment_date4: null,
        invoice_no5: '',
        invoice_date5: null,
        invoice_foreign5: null,
        invoice5: null,
        invoice_payee5: null,
        invoice_payment_date5: null,
        airfreight_no1: '',
        airfreight_foreign1: null,
        airfreight1: null,
        airfreight_payee1: null,
        airfreight_payment_date1: null,
        airfreight_date1: null,
        airfreight_divide1: null,
        airfreight_no2: '',
        airfreight_foreign2: null,
        airfreight2: '',
        airfreight_divide2: null,
        airfreight_payee2: null,
        airfreight_payment_date2: null,
        airfreight_date2: null,
        airfreight_no3: '',
        airfreight_foreign3: null,
        airfreight3: '',
        airfreight_divide3: null,
        airfreight_payee3: null,
        airfreight_payment_date3: null,
        airfreight_date3: null,
        supplier_fumigation: null,
        supplier_fumigation_foreign: null,
        supplier_fumigation_divide: null,
        supplier_fumigation_payee: null,
        supplier_fumigation_payment_date: null,
        credit: null,
        credit_foreign: null,
        credit_payee: null,
        credit_payment_date: null,
        credit_statement: null,
        adjustment: null,
        adjustment_foreign: null,
        adjustment_payee: null,
        adjustment_payment_date: null,
        candf: null,
        invoice_statement: null,
        trans_dom: null,
        deban: null,
        shifting: null,
        airpacking: null,
        uwaya: null,
        clearing_date: null,
        clearing: null,
        clearing_divide: null,
        fumigation_company: null,
        fumigation_date: null,
        fumigation: null,
        dispose: null,
        purchase_adjustment: null,
        custom: null,
        rinji_kaicho: null,
        claim: null,
        siire: null,
        sales: null,
        profit: null,
        acc_confirmed_by: null,
        acc_confirmed_at: null,
        sales_confirmed_by: null,
        sales_confirmed_at: null,
        salesreport_final_by: null,
        salesreport_final_at: null,
        customer_claim: null
      }
    },
    resetFileNeeds (state) {
      state.shipment_file_needs = []
    },
    resetPayee (state) {
      state.cost.invoice_payee1 = null
      state.cost.invoice_payee2 = null
      state.cost.invoice_payee3 = null
      state.cost.invoice_payee4 = null
      state.cost.invoice_payee5 = null
      state.cost.airfreight_payee1 = null
      state.cost.airfreight_payee2 = null
      state.cost.airfreight_payee3 = null
      state.cost.credit_payee = null
      state.cost.adjustment_payee = null
      state.cost.supplier_fumigation_payee = null
    },
    updateUwayaByAwb (state) {
      if (state.info.awb && state.info.awb.length > 2) {
        let firstThree = state.info.awb.substring(0, 3)
        let select = state.awb_to_uwayas.find((row) => {
          return row.awbs.indexOf(firstThree) > -1
        })
        if (select) {
          let index = state.uwayas.findIndex((row) => {
            return row.id === select.uwaya.id
          })
          if (index > -1) {
            state.logi.uwaya = state.uwayas[index]
          }
        }
      }
    },
    selectFileNeed (state, updateValue) {
      if (state.shipment_file_needs[updateValue.index] !== undefined) {
        state.shipment_file_needs[updateValue.index].need = updateValue.value
      }
    },
    initFileNeeds (state) {
      let fileneeds = []
      state.filetypes.forEach(filetype => {
        let fileneed = {}
        let index = state.shipment_file_needs.findIndex((row) => {
          return row.filetype === filetype.id
        })
        if (index > -1) {
          fileneed.id = state.shipment_file_needs[index].id
          fileneed.shipment = state.shipment_file_needs[index].shipment
          fileneed.filetype = state.shipment_file_needs[index].filetype
          fileneed.need = 1
        } else { // add new row to data
          fileneed.id = null
          fileneed.shipment = null
          fileneed.filetype = filetype.id
          fileneed.need = 0
        }
        fileneeds.push(fileneed)
      })
      state.shipment_file_needs = fileneeds
    },
    addFile (state, file) {
      state.shipment_files.push(file)
    },
    removeFile (state, index) {
      let file = state.shipment_files[index]
      if (!file.id) {
        state.shipment_files.splice([index], 1)
      } else {
        file.removed = true
        state.shipment_files.splice([index], file)
      }
    },
    setShipmentFormula (state, shipmentFormulas) {
      state.shipment_formulas = shipmentFormulas
    },
    onFocusFormula (state, prop) {
      let index = state.shipment_formulas.findIndex((row) => {
        return row.property === prop
      })
      // convert shipment_cost_rate --> cost.rate
      let table = ''
      let key = ''
      if (prop.startsWith('shipment_cost_')) {
        table = 'cost'
        key = prop.replace('shipment_cost_', '')
      } else {
        return true
      }

      if (index > -1 && !state.shipment_formulas[index].removed) {
        // state.cost[prop] = state.shipment_formulas[index].formula
        state[table][key] = state.shipment_formulas[index].formula
      }
    },
    onBlurFormula (state, prop) {
      let index = state.shipment_formulas.findIndex((row) => {
        return row.property === prop
      })
      // convert shipment_cost_rate --> cost.rate
      let table = ''
      let key = ''
      if (prop.startsWith('shipment_cost_')) {
        table = 'cost'
        key = prop.replace('shipment_cost_', '')
      } else {
        return true
      }
      const pattern = /^-?[0-9+\-*/^%().]*$/
      if (isNaN(state[table][key]) && pattern.test(state[table][key])) {
        try {
          if (index > -1) {
            state.shipment_formulas[index].formula = state[table][key]
            state.shipment_formulas[index].removed = 0
          } else {
            if (state[table][key] === null) {
              return false
            }
            let f = {
              id: null,
              shipment: null,
              property: prop,
              formula: state[table][key],
              removed: 0
            }
            state.shipment_formulas.push(f)
          }

          let e = function (formula) {
            let Fn = Function
            let func = new Fn('return ' + formula)
            return func()
          }
          state[table][key] = Math.round(e(state[table][key]) * 100) / 100
        } catch (err) {
          console.log(err)
          return false
        }
      } else {
        if (index > -1) {
          state.shipment_formulas[index].removed = 1
        }
      }
      return true
    },
    addSelected (state, id) {
      state.selected_ids.push(id)
    },
    removeSelected (state, id) {
      let index = state.selected_ids.indexOf(id)
      if (index > -1) {
        state.selected_ids.splice(index, 1)
      }
    },
    addSelectedChart (state, id) {
      state.selected_chart_ids.push(id)
    },
    removeSelectedChart (state, id) {
      let index = state.selected_chart_ids.indexOf(id)
      if (index > -1) {
        state.selected_chart_ids.splice(index, 1)
      }
    },
    addSelectedDate (state, [date, data]) {
      state.selected_all_dates.push(date)
      let ids = data.map(({ id }) => id)
      if (ids.length > 0) {
        state.selected_ids = [...new Set([...state.selected_ids, ...ids])]
      }
    },
    removeSelectedDate (state, [date, data]) {
      let index = state.selected_all_dates.indexOf(date)
      if (index > -1) {
        state.selected_all_dates.splice(index, 1)
        let ids = data.map(({ id }) => id)
        if (ids.length > 0) {
          state.selected_ids = state.selected_ids.filter((id) => {
            return ids.indexOf(id) === -1
          })
        }
      }
    },
    resetSelectedIds (state) {
      state.selected_ids = []
    },
    resetSelectedChartIds (state) {
      state.selected_chart_ids = []
    },
    resetSelectedDate (state) {
      state.selected_all_dates = []
    }
  },
  actions: {
    updateInfo ({commit}, info) {
      commit('updateInfo', info)
    },
    updateLogi ({commit}, logi) {
      commit('updateLogi', logi)
    },
    updateCost ({commit}, cost) {
      commit('updateCost', cost)
    },
    updateRepack ({commit}, repack) {
      commit('updateRepack', repack)
    },
    updateClaim ({commit}, claim) {
      commit('updateClaim', claim)
    },
    updateSummary ({commit}, summary) {
      commit('updateSummary', summary)
    },
    updateFiletypes ({commit}, filetypes) {
      commit('updateFiletypes', filetypes)
    },
    updateShipmentTemperatures ({commit}, shipmentTemperatures) {
      commit('updateShipmentTemperatures', shipmentTemperatures)
    },
    updateShipmentBug ({commit}, shipmentBug) {
      commit('updateShipmentBug', shipmentBug)
    },
    setArrivalDate ({commit}, arrivalDate) {
      commit('setArrivalDate', arrivalDate)
    },
    setPorts ({commit}, ports) {
      commit('setPorts', ports)
    },
    setSuppliers ({commit}, suppliers) {
      commit('setSuppliers', suppliers)
    },
    setMembers ({commit}, members) {
      commit('setMembers', members)
    },
    setShipments ({commit}, shipments) {
      commit('setShipments', shipments)
    },
    setOptionsBps ({commit}, optionsBps) {
      commit('setOptionsBps', optionsBps)
    },
    setOptionsPqs ({commit}, optionsPqs) {
      commit('setOptionsPqs', optionsPqs)
    },
    setFumigationTypes ({commit}, fumigationTypes) {
      commit('setFumigationTypes', fumigationTypes)
    },
    setFumigationCompanies ({commit}, fumigationCompanies) {
      commit('setFumigationCompanies', fumigationCompanies)
    },
    setHanshutsuStatuses ({commit}, statuses) {
      commit('setHanshutsuStatuses', statuses)
    },
    setUwayas ({commit}, uwayas) {
      commit('setUwayas', uwayas)
    },
    setItems ({commit}, items) {
      commit('setItems', items)
    },
    setWorms ({commit}, worms) {
      commit('setWorms', worms)
    },
    setAwbToUwayas ({commit}, awb) {
      commit('setAwbToUwayas', awb)
    },
    setWarehouses ({commit}, warehouses) {
      commit('setWarehouses', warehouses)
    },
    setLogiCenters ({commit}, logiCenters) {
      commit('setLogiCenters', logiCenters)
    },
    setLogiCenterMappings ({commit}, logiCenterMappings) {
      commit('setLogiCenterMappings', logiCenterMappings)
    },
    setTemperatures ({commit}, temperatures) {
      commit('setTemperatures', temperatures)
    },
    setTemperatureStates ({commit}, temperatureStates) {
      commit('setTemperatureStates', temperatureStates)
    },
    setTemperaturePresets ({commit}, temperaturePresets) {
      commit('setTemperaturePresets', temperaturePresets)
    },
    setRepackPlaces ({commit}, repackPlaces) {
      commit('setRepackPlaces', repackPlaces)
    },
    setPayees ({commit}, payees) {
      commit('setPayees', payees)
    },
    setPresetDefault ({commit}, presetDefault) {
      commit('setPresetDefault', presetDefault)
    },
    updateShipmentFileNeeds ({commit}, shipmentFileNeeds) {
      commit('updateShipmentFileNeeds', shipmentFileNeeds)
    },
    setShipmentFiles ({commit}, shipmentFiles) {
      commit('setShipmentFiles', shipmentFiles)
    },
    selectFileNeed ({commit}, updateValue) {
      commit('selectFileNeed', updateValue)
    },
    setShipmentFormula ({commit}, shipmentFormulas) {
      commit('setShipmentFormula', shipmentFormulas)
    },
    selectShipmentTemperature ({commit}, updateValue) {
      commit('selectShipmentTemperature', updateValue)
    },
    setShipmentSalesInfo ({commit}, shipmentSalesInfo) {
      commit('setShipmentSalesInfo', shipmentSalesInfo)
    },
    setClaimInfo ({commit}, claim) {
      commit('setClaimInfo', claim)
    },
    initFileNeeds ({commit}) {
      commit('initFileNeeds')
    },
    emptyShipmentStore ({commit}) {
      commit('updateInfo', null)
      commit('updateLogi', null)
      commit('updateCost', null)
      commit('updateSummary', null)
      commit('updateFiletypes', [])
      commit('setArrivalDate', null)
      commit('setPorts', [])
      commit('setSuppliers', [])
      commit('setMembers', [])
      commit('setShipments', [])
      commit('setOptionsBps', [])
      commit('setOptionsPqs', [])
      commit('setFumigationTypes', [])
      commit('setFumigationCompanies', [])
      commit('setUwayas', [])
      commit('setAwbToUwayas', [])
      commit('setWarehouses', [])
      commit('setLogiCenters', [])
      commit('setLogiCenterMappings', [])
      commit('setTemperatures', [])
      commit('setTemperatureStates', [])
      commit('updateShipmentFileNeeds', [])
      commit('updateShipmentTemperatures', [])
      commit('setShipmentSalesInfo', [])
      commit('setClaimInfo', [])
      commit('setShipmentFiles', [])
      commit('setHanshutsuStatuses', [])
      commit('setItems', [])
      commit('setPayees', [])
      commit('setRepackPlaces', [])
      commit('setTemperatureStates', [])
      commit('setTemperaturePresets', [])
      commit('setWorms', [])
    },
    resetInfo ({commit}) {
      commit('resetInfo')
    },
    resetShipmentSalesInfo ({commit}) {
      commit('setShipmentSalesInfo', [])
    },
    resetClaimInfo ({commit}) {
      commit('setClaimInfo', [])
    },
    resetLogi ({commit}) {
      commit('resetLogi')
    },
    resetCost ({commit}) {
      commit('resetCost')
    },
    resetSummary ({commit}) {
      commit('resetSummary')
    },
    resetPayee ({commit}) {
      commit('resetPayee')
    },
    resetFileNeeds ({commit}) {
      commit('resetFileNeeds')
    },
    resetSelectedIds ({commit}) {
      commit('resetSelectedIds')
    },
    resetSelectedChartIds ({commit}) {
      commit('resetSelectedChartIds')
    },
    resetSelectedDate ({commit}) {
      commit('resetSelectedDate')
    },
    addFile ({commit}, file) {
      commit('addFile', file)
    },
    removeFile ({commit}, file) {
      commit('removeFile', file)
    },
    onFocusFormula ({commit}, prop) {
      commit('onFocusFormula', prop)
    },
    onBlurFormula ({commit}, prop) {
      commit('onBlurFormula', prop)
    },
    addSelected ({commit}, id) {
      commit('addSelected', id)
    },
    removeSelected ({commit}, id) {
      commit('removeSelected', id)
    },
    addSelectedChart ({commit}, id) {
      commit('addSelectedChart', id)
    },
    removeSelectedChart ({commit}, id) {
      commit('removeSelectedChart', id)
    },
    addSelectedDate ({commit}, data) {
      commit('addSelectedDate', data)
    },
    removeSelectedDate ({commit}, data) {
      commit('removeSelectedDate', data)
    },
    updateUwayaByAwb ({commit}, awb) {
      commit('updateUwayaByAwb', awb)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Timetable/store.js